import MenuFrame from "../frames/menu_frame";
import { getDayBooking, getTotalAmountDayBooking } from "../edit/edit_halper";
import { Backdrop, CircularProgress, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { dateUsaToInd, getCurrentDate, getCurrentMonthStart } from "../frames/common";
import { useState } from "react";
import { calcTotalDesk } from "../booking/booking_halper";
import Loading2 from "../frames/loading2";

const cu_date = getCurrentDate();
let allCns = [];

function DayBookingList() {
    const [isLoading, setIsLoading] = useState(false);
    const [cnList, setCnList] = useState(null);
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);

    const initData = async (auth) => {
        if (!auth) return;
        try {
            const res = await getDayBooking({ interval: "month" });
            allCns = res;
            setCnList(res);
        } catch (error) {
            setCnList([]);
        }
    }

    const handleSpanChange = (e) => {
        setIsLoading(true);
        getDayBooking({ interval: e.target.value }).then((res) => {
            allCns = res;
            setCnList(res);
            setIsLoading(false);
        }).catch((err) => {
            console.error(err);
            setCnList([]);
            setIsLoading(false);
        });
    }

    const handleTimeChange = (event, start) => {
        if (event.target.value === "") return;
        const _json = { interval: null, start: startTime ?? dateUsaToInd(getCurrentMonthStart()), end: endTime ?? dateUsaToInd(cu_date) };
        const n_date = dateUsaToInd(event.target.value);
        if (start) {
            setStartTime(n_date);
            _json["start"] = n_date;
        } else {
            setEndTime(n_date);
            _json["end"] = n_date;
        }
        setIsLoading(true);
        getDayBooking(_json).then((res) => {
            allCns = res;
            setCnList(res);
            setIsLoading(false);
        }).catch((err) => {
            console.error(err);
            setCnList([]);
            setIsLoading(false);
        });
    }

    const filterCns = (search) => {
        const tmp = allCns.filter((itm) => itm.cn_no.startsWith(search.target.value.trim()));
        if (tmp.length === 0) setCnList(allCns);
        else setCnList(tmp);
    }

    return (
        <MenuFrame permission="BILLING_ORG" onSearch={filterCns} screen="DESK_BILL" onInit={initData}>
            <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={isLoading} >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <FormControl fullWidth>
                        <InputLabel id="time-span">Span</InputLabel>
                        <Select
                            autoFocus
                            labelId="time-span"
                            id="time-span"
                            label="Time Span"
                            defaultValue={"month"}
                            onChange={handleSpanChange}
                        >
                            <MenuItem value={""}>None</MenuItem>
                            <MenuItem value={"day"}>Day</MenuItem>
                            <MenuItem value={"month"}>Month</MenuItem>
                            <MenuItem value={"last-month"}>Last Month</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField variant="outlined" name="start_date" type="date" fullWidth defaultValue={getCurrentMonthStart()} slotProps={{ htmlInput: { max: cu_date, min: "2014-04-01" } }} placeholder="Start Date" onChange={(e) => { handleTimeChange(e, true) }} />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField variant="outlined" name="end_date" type="date" fullWidth defaultValue={cu_date} slotProps={{ htmlInput: { max: cu_date, min: "2014-04-01" } }} placeholder="End Date" onChange={(e) => { handleTimeChange(e, false) }} />
                </Grid>
            </Grid>

            <Typography variant="body2">{cnList?.length ?? 0} booking with total value ₹ {getTotalAmountDayBooking(cnList)}</Typography>

            <TableContainer component={Paper}>
                <Table size="small" stickyHeader aria-label="Consignments" className="nowrap">
                    <TableHead>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { fontWeight: "bold" } }}>
                            <TableCell>Date</TableCell>
                            <TableCell>Consignment</TableCell>
                            <TableCell>Address</TableCell>
                            <TableCell align="right">Weight(Grm)</TableCell>
                            <TableCell align="right">Total</TableCell>
                            <TableCell align="right">Price</TableCell>
                            <TableCell align="right">PPI</TableCell>
                            <TableCell align="right">Fuel</TableCell>
                            <TableCell align="right">GST</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {cnList === null ? <TableRow><TableCell colSpan={13}><Loading2 /></TableCell></TableRow> :
                            cnList.length === 0 ?
                                <TableRow><TableCell colSpan={13} style={{ textAlign: "center" }}><Typography variant="subtitle2" color="textDisabled">No data to display</Typography></TableCell></TableRow> :
                                cnList.map((row, idx) =>
                                    <TableRow key={idx}>
                                        <TableCell>
                                            <Typography variant="body2">{row.created}</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2">{row.cn_no}</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2">{row.destination} - {row.pincode}</Typography>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Typography variant="body2">{row.weight}</Typography>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Typography variant="body2" color="primary">{calcTotalDesk(row)}</Typography>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Typography variant="body2" color="primary">{(row.amount).toFixed(2)}</Typography>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Typography variant="body2" color="primary">{(row.pickup + row.packaging + row.other + row.insurance).toFixed(2)}</Typography>
                                        </TableCell>
                                        <TableCell align="right"><Typography variant="body2" color="primary">{row.fuel.toFixed(2)}</Typography></TableCell>
                                        <TableCell align="right"><Typography variant="body2" color="primary">{row.gst.toFixed(2)}</Typography></TableCell>
                                    </TableRow>
                                )
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <Typography variant="caption" color="textSecondary">Insurance includng 18% GST</Typography>
        </MenuFrame>
    );
}

export default DayBookingList;
